"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleWrapper = exports.Panel = exports.CloseButton = exports.BgOverlay = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _sharedStyle = require("../../../sharedStyle");
var _Nav = require("../Nav/Nav.style");
const {
  colours
} = _uiKit.theme;
const BgOverlay = exports.BgOverlay = _styledComponents.default.div.withConfig({
  displayName: "Panelstyle__BgOverlay",
  componentId: "sc-12jee21-0"
})(["position:fixed;top:", "px;left:0;right:0;width:100vw;max-width:", "px;bottom:", "px;background-color:", ";z-index:5;"], _sharedStyle.headerHeight, _sharedStyle.navWidth, _Nav.footerNavHeight, colours.WHITE);
const Panel = exports.Panel = _styledComponents.default.div.withConfig({
  displayName: "Panelstyle__Panel",
  componentId: "sc-12jee21-1"
})(["position:absolute;bottom:", "px;", " left:0;width:100vw;max-width:", "px;background-color:", ";z-index:5;"], _Nav.footerNavHeight, _ref => {
  let {
    isAnnouncements
  } = _ref;
  return isAnnouncements ? "top: ".concat(_sharedStyle.headerHeight, "px;") : "";
}, _sharedStyle.navWidth, colours.WHITE);
const CloseButton = exports.CloseButton = _styledComponents.default.button.withConfig({
  displayName: "Panelstyle__CloseButton",
  componentId: "sc-12jee21-2"
})(["background:none;border:none;width:52px;text-align:center;"]);
const TitleWrapper = exports.TitleWrapper = _styledComponents.default.div.withConfig({
  displayName: "Panelstyle__TitleWrapper",
  componentId: "sc-12jee21-3"
})(["height:52px;display:flex;justify-content:space-between;align-items:center;padding-left:16px;"]);